export interface ShouldReconcileArgs {
  /** True when the local editor has unsaved user edits. */
  dirty: boolean;
  /** Latest note_content from the cache for the open note (undefined if gone). */
  remoteContent: string | undefined;
  /** Content the editor currently reflects: last loaded/reconciled, or last
   *  value THIS instance saved (own-echo marker). */
  lastSyncedContent: string;
}

/**
 * Reconcile (push remote content into the open editor) ONLY when:
 *  - the editor is NOT dirty (never yank text from under someone typing), AND
 *  - remote content exists, AND
 *  - remote content DIFFERS from what the editor currently holds
 *    (this single check rejects BOTH "no real change" AND our own save echo,
 *    because after we save we set lastSyncedContent to exactly what we wrote).
 * Otherwise skip.
 *
 * NOTE: the content-differs test compares the cached content against a stored
 * last-known marker (lastSyncedContent), NOT the editor's live re-normalized
 * serialization. Comparing the editor's serialized HTML would oscillate because
 * TipTap re-normalizes on load — see the Notepad Integration notes. Keeping the
 * compare against the marker is what makes this loop-safe.
 */
export function shouldReconcileNote(args: ShouldReconcileArgs): boolean {
  const { dirty, remoteContent, lastSyncedContent } = args;
  if (dirty) return false;
  if (remoteContent === undefined) return false;
  return remoteContent !== lastSyncedContent;
}
